import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const IncomingDocumentsDynamicPage = lazy(() => import('./IncomingDocumentsDynamicPage'));
const Signed = lazy(() => import('./Signed'));
const OnSigning = lazy(() => import('./OnSigning'));
const OnExecution = lazy(() => import('./OnExecution'));
const Executed = lazy(() => import('./Executed'));
const DocumentChecking = lazy(() => import('./DocumentChecking'));
const Rejected = lazy(() => import('./Rejected'));
const Archived = lazy(() => import('./Archived'));

const IncomingDocumentsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/documents/on-signing',
      element: <OnSigning />,
    },
    {
      path: 'apps/documents/signed',
      element: <Signed />,
    },
    {
      path: 'apps/documents/in-execution',
      element: <OnExecution />,
    },
    {
      path: 'apps/documents/:status/:id',
      element: <IncomingDocumentsDynamicPage />,
    },
    {
      path: 'apps/documents/completed',
      element: <Executed />,
    },
    {
      path: 'apps/documents/rejected',
      element: <Rejected />,
    },
    {
      path: '/apps/documents/archived',
      element: <Archived />,
    },
    {
      path: '/apps/documents/checking',
      element: <DocumentChecking />,
    },
  ],
};

export default IncomingDocumentsConfig;
